import { Button } from '@/components/ui/button';
import {
  DialogHeader as ShadcnDialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { getMonthNameByDate } from '@/utils';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { useRouteParams } from '../useRouteParams';

export function DialogHeaderFallback() {
  const { t } = useTranslation();
  const { searchParams } = useRouteParams();

  return (
    <ShadcnDialogHeader>
      <div className="flex flex-col gap-6">
        <DialogTitle className="text-xl font-bold text-neutrals-N900">
          {t('domain.controlling.umsatzplanung.ziele.dialog.title')}
        </DialogTitle>
        <div className="flex items-center gap-4">
          <Button variant="outline-secondary" size="sm" disabled>
            {t('general.date.today')}
          </Button>
          <div className="flex items-center">
            <Button
              size="icon"
              variant="icon"
              disabled
              className="text-neutrals-N700 disabled:text-neutrals-N500">
              <FontAwesomeIcon className="text-xl" icon={faChevronLeft} />
            </Button>
            <Button
              size="icon"
              variant="icon"
              disabled
              className="text-neutrals-N700 disabled:text-neutrals-N500">
              <FontAwesomeIcon className="text-xl" icon={faChevronRight} />
            </Button>
          </div>
          <Button className="font-bold" variant="ghost" disabled>
            {getMonthNameByDate(
              dayjs(`${searchParams.jahr}-${searchParams.monat}-01`).format(
                'YYYY-MM-DD',
              ),
            )}
          </Button>
        </div>
      </div>
    </ShadcnDialogHeader>
  );
}
